module.exports = __webpack_public_path__ + "7151d73e096ba45b8fe042b36b2560bb.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/sites/fitness/favicon.ico
// module id = 1845
// module chunks = 1